<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="createSatelite"
    >
      <header class="m-the-modal-header">
        <h5>
          {{ $t(`mEditionBillingSatellites.modal.title${sufijo}`) }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>

      <section
        key="modalSection"
        class="m-the-modal-section-height-auto m-satellites-modal"
      >
        <AtomInputPrimary
          v-model="form.titulo"
          :input-error="errors.titulo"
          :label="$t('mEditionBillingSatellites.modal.fields.titulo')"
          :message-error="$t('mEditionBillingSatellites.modal.errors.titulo')"
          :placeholder="$t(`mEditionBillingSatellites.modal.fields.tituloPlaceholder.${tab}`)"
          name="titulo"
          type="text"
        />

        <!-- Los maximos no se cargan a mano: los define el plan elegido -->
        <AtomSelectPrimary
          v-model="form.plan"
          :elements="planesElements"
          :input-error="errors.plan"
          key-field="plan"
          :label="$t('mEditionBillingSatellites.modal.fields.plan')"
          :message-error="$t('mEditionBillingSatellites.modal.errors.plan')"
          text-field="nombre"
        />

        <ul
          v-if="planSeleccionado"
          class="m-satellites-modal-limits"
        >
          <li
            v-for="limite in limitesDelPlan"
            :key="limite.key"
          >
            <span>{{ limite.label }}</span>
            <b>{{ limite.value }}</b>
          </li>
        </ul>

        <h6 class="m-satellites-modal-subtitle margin-top-large">
          {{ $t('mEditionBillingSatellites.modal.fields.imagen') }}
        </h6>

        <!-- Miniatura chica al lado del boton: la vista previa muestra el recorte real sin
             estirar el modal -->
        <div class="m-satellites-modal-image-edition">
          <div class="m-satellites-modal-image-thumb">
            <img
              v-if="imagenPreview"
              :alt="form.titulo"
              :src="imagenPreview"
            >
            <img
              v-else
              alt=""
              src="@/assets/img/ds2.png"
            >
          </div>

          <div class="m-satellites-modal-image-actions">
            <a
              class="a-button-billing-secondary"
              href="#"
              @click.prevent="$refs.imagen.click()"
            >
              <i class="far fa-image"></i>
              {{ $t('mEditionBillingSatellites.modal.fields.imagenButton') }}
            </a>
          </div>

          <input
            v-show="false"
            ref="imagen"
            accept="image/*"
            name="imagen"
            type="file"
            @change="onImagenChange"
          >
        </div>

        <p class="m-satellites-modal-note">
          <i class="fas fa-info-circle"></i>
          <span>{{ $t('mEditionBillingSatellites.modal.hint') }}</span>
        </p>
      </section>

      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction
          :cancel-text="$t('mEditionBillingSatellites.modal.buttons.cancel')"
        />
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
import { sufijoDe } from '@/plugins/satelites/droops'

export default {
  name: 'MoleculeEditionBillingSatellitesModal',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingSatellites.modal.buttons.submit'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      },

      errors: {
        plan: false,
        titulo: false
      },

      form: {
        imagen: null,
        plan: '',
        titulo: ''
      },

      imagenPreview: null,

      planes: [],
      tab: 'juedroop'
    }
  },

  computed: {
    sufijo () {
      return sufijoDe(this.tab)
    },

    planesElements () {
      return this.planes
    },

    planSeleccionado () {
      return this.planes.find(plan => plan.plan === this.form.plan)
    },

    // Se muestran los limites del plan elegido para que quede claro que se esta creando
    limitesDelPlan () {
      if (!this.planSeleccionado) {
        return []
      }

      return Object.keys(this.planSeleccionado)
        .filter(clave => clave !== 'plan' && clave !== 'nombre')
        .map(clave => ({
          key: clave,
          label: this.$t(`mEditionBillingSatellites.card.limites.${this.camelize(clave)}`),
          value: typeof this.planSeleccionado[clave] === 'boolean'
            ? (this.planSeleccionado[clave] ? 'Sí' : 'No')
            : this.planSeleccionado[clave]
        }))
    }
  },

  created () {
    this.planes = this.$modal.element.planes || []
    this.tab = this.$modal.element.tab
  },

  methods: {
    camelize (text) {
      return text.replace(/_([a-z])/g, (match, letra) => letra.toUpperCase())
    },

    endpointDe (accion) {
      return `${accion}Satelite${this.sufijo}`
    },

    onImagenChange (event) {
      const input = event.target

      if (!input.files || !input.files[0]) {
        return
      }

      const archivo = input.files[0]

      // Mismas validaciones que usa app-academy al cambiar la imagen de una tarjeta
      if (!this.$files.allowedFileExtension(archivo.name, 'image')) {
        this.$alerts.pushAlert('mEditionBillingSatellites', 'imagenExtension', 'error', 'a-alert-danger')
        input.value = ''

        return
      }

      if (!this.$files.allowedFileSize(archivo.name, archivo.size)) {
        this.$alerts.pushAlert('mEditionBillingSatellites', 'imagenSize', 'error', 'a-alert-danger')
        input.value = ''

        return
      }

      this.form.imagen = archivo

      const reader = new FileReader()
      reader.onload = (e) => {
        this.imagenPreview = e.target.result
      }
      reader.readAsDataURL(archivo)
    },

    validate () {
      this.errors.titulo = !this.form.titulo ||
        this.form.titulo.length < 3 ||
        this.form.titulo.length > 120
      this.errors.plan = !this.form.plan

      return !this.errors.titulo && !this.errors.plan
    },

    createSatelite () {
      if (this.buttonPrimary.sending || !this.validate()) {
        return
      }

      this.buttonPrimary.sending = true

      const data = {
        satelite: {
          titulo: this.form.titulo,
          plan: this.form.plan
        }
      }

      this.$services.create('satelite', this.endpointDe('create'), data)
        .then(response => {
          // La imagen va aparte, igual que en productos: primero existe el satelite y despues se le
          // sube el archivo
          if (this.form.imagen) {
            return this.uploadImagen(response.data.id)
          }
        })
        .then(() => {
          this.$alerts.pushAlert('mEditionBillingSatellites', 'createSatelite', 'success', 'a-alert-success')
          this.$modal.updateData('readSatelites')
          this.$modal.closeModal()
        })
        .catch(() => {
          this.$alerts.pushAlert('mEditionBillingSatellites', 'createSatelite', 'error', 'a-alert-danger')
        })
        .finally(() => {
          this.buttonPrimary.sending = false
        })
    },

    uploadImagen (uuidSatelite) {
      const formData = new FormData()
      formData.append('imagen', this.form.imagen)

      const endpoint = `uploadSatelite${this.sufijo}Imagen`

      return this.$services.create('satelite', endpoint, formData, [uuidSatelite])
    }
  }
}
</script>
